module.exports = __webpack_public_path__ + "img/product-placeholder-81.0434143.png";